import React from 'react'
import { func, oneOf, object, string, bool } from 'prop-types'
import { translate } from 'react-i18next'
import { InquiryTypes } from '../../../constants/InquiryTypes'
import { InquiryFrequencies } from '../../../constants/InquiryFrequencies'
import { InquiryDetailsProposalCount } from '../../../components/inquiries/InquiryDetailsProposalCount'
import { InquiryDetailsProposal } from '../../../components/inquiries/InquiryDetailsProposal'
import { QuotationButtons } from '../../../components/ui/buttons/QuotationButtons'
import { SelectGardenerButton } from '../../../components/ui/buttons/SelectGardenerButton'
import { InquiryDetailsPayment } from '../../../components/inquiries/InquiryDetailsPayment'
import { Loader } from '../../../components/ui/states/Loader'

export const ProposalsWaiting = translate()(({
  t, type, frequency, onSelect, selected, payment, inquiry, hidden
}) => (
  <div className='demandes__section'>
    <InquiryDetailsProposalCount count={inquiry.proposals ? inquiry.proposals.length : 0} />
    {
      inquiry.proposals.map((p) => (
        <InquiryDetailsProposal key={p.id} proposal={p} only={selected} type={type} frequency={frequency}>
          <SelectGardenerButton id={p.id} name={p.name} onSubmit={(id) => onSelect(id)} hidden={hidden || !!selected} />
          <QuotationButtons proposal={p} />
        </InquiryDetailsProposal>
      ))
    }
    {
      payment && payment.loading
      ? <Loader size='medium' message={t('common:visits:payment_loading')} />
      : ''
    }
    {
      payment && payment.total !== undefined
      ? <InquiryDetailsPayment payment={payment} />
      : ''
    }
  </div>
))

ProposalsWaiting.propTypes = {
  t: func,
  inquiry: object,
  payment: object,
  hidden: bool,
  selected: string,
  onSelect: func,
  type: oneOf(Object.values(InquiryTypes)),
  frequency: oneOf(Object.values(InquiryFrequencies))
}



// WEBPACK FOOTER //
// ./src/pages/demandes/realisations/ProposalsWaiting.js